import moment from 'moment';
import tinycolor from 'tinycolor2';

const Utils = {
  isValidEmail: (email: string) => {
    const re = /^[\w\\+]+([\\.-]?\w+)@\w+([\\.-]?\w+)(\.\w{1,8})+$/;

    if (!re.test(email)) {
      return false;
    }
    return true;
  },
  getAMPMtime: (hour?: any) => {
    return moment(hour, ['HH:mm:ss']).format('hh:mm A');
  },
  getAMPMtimeWithoutFormat: (hour?: any) => {
    return moment(hour).format('hh:mm A');
  },
  getOnlyDate: (hour?: any) => {
    return moment(hour).format('dddd MMM DD, yyyy');
  },
  getDay: (no?: number) => {
    let day = '';
    switch (no) {
      case 1: {
        day = 'SUN';
        break;
      }
      case 2: {
        day = 'MON';
        break;
      }
      case 3: {
        day = 'TUE';
        break;
      }
      case 4: {
        day = 'WED';
        break;
      }
      case 5: {
        day = 'THU';
        break;
      }
      case 6: {
        day = 'FRI';
        break;
      }
      case 7: {
        day = 'SAT';
        break;
      }
    }
    return day;
  },

  getDateConfig: (inputDateStr: any): string => {
    const followUpDate = new Date(inputDateStr); // Create Date object from follow-up date
    const today = new Date(); // Current date
    
    // Set time to midnight for accurate comparison
    today.setHours(0, 0, 0, 0);
    followUpDate.setHours(0, 0, 0, 0);
    
    let dateStatus = '';
    
    if (followUpDate < today) {
      dateStatus = 'expired';
    } else if (followUpDate.getTime() === today.getTime()) {
      dateStatus = 'today';
    } else {
      dateStatus = 'future';
    }
    return dateStatus;
  },
  formatDate: (inputDateStr: any): string => {
    if (!inputDateStr) {
      return 'Invalid Date';
    }

    const inputDate = new Date(inputDateStr);
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }

    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${day} ${monthNames[month]}, ${year}`;
    return formattedDate;
  },
  formatOnlyDay(inputDateStr: string) {
    const inputDate = new Date(inputDateStr);
    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const day = inputDate.getDate();
    const month = inputDate.getMonth();
    const year = inputDate.getFullYear();
    const formattedDate = `${monthNames[month]} ${day},`;
    return formattedDate;
  },
  timeAgo(inputDateStr: Date): string {
    const now = new Date();
    const past = new Date(inputDateStr);
    const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);
  
    const units = [
      { name: 'year', seconds: 31536000 },
      { name: 'month', seconds: 2592000 },
      { name: 'week', seconds: 604800 },
      { name: 'day', seconds: 86400 },
      { name: 'hour', seconds: 3600 },
      { name: 'minute', seconds: 60 },
      { name: 'second', seconds: 1 }
    ];
  
    for (const unit of units) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return interval === 1 ? `1 ${unit.name} ago` : `${interval} ${unit.name}s ago`;
      }
    }
  
    return 'just now';
  },

darkenColor (hex:string) : string{
  const lightColor = tinycolor(hex).darken(20).toString();
  return lightColor
},
 getCities (location: any) : any {
  if (location && location.length > 0) {
    const citys = location.map((loc: any) => loc.city);
    const uniqueCity = Array.from(new Set(citys.map((city: any) => city.id)))
      .map((id) => citys.find((city: any) => city.id === id)?.name);
    const firstThreeCity = uniqueCity.slice(0, 2);
    const remainingCount = uniqueCity.length - 2;

    return {
      firstThreeCity,
      remainingCount: remainingCount > 0 ? remainingCount : 0,
    };
  }
  return { firstThreeCity: [], remainingCount: 0 };
},

getPhone (phone: any) : any  {
  if (!phone) return ''; 
  return phone.startsWith('+') ? phone : `+${phone}`;
},

getOnly10CITY (location: any) : any {
  if (location && location.length > 0) {
    const sortedLocations = location.sort((a: any, b: any) => a.name.localeCompare(b.name));
    const citys = sortedLocations.map((loc: any) => loc.name);
   // const citys = location.map((loc: any) => loc.name);
    const firstTenCity = citys.slice(0, 10);
    const remainingCount = citys.length - 10;

    return {
      firstTenCity,
      remainingCount: remainingCount > 0 ? remainingCount : 0,
    };
  }
  return { firstTenCity: [], remainingCount: 0 };
},

convertTimestampToTimeFormat: (timestamp: string) => {
  const date = new Date(timestamp);

  const hours = date.getHours() % 12 || 12; // Converts 24-hour to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const amPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' }); // Get month in "MMM" format
  const year = date.getFullYear().toString(); // Get year in "YY" format

  return ` ${day} ${month} ${year}`;
},

convertTimestampToTimeFormatWithTime: (timestamp: string) => {
  const date = new Date(timestamp);

  const hours = date.getHours() % 12 || 12; // Converts 24-hour to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const amPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' }); // Get month in "MMM" format
  const year = date.getFullYear().toString(); // Get year in "YY" format

  return `${day} ${month} ${year}, ${hours}:${minutes} ${amPm}`;
},

 convertDateToISOFormat : (dateString:any) =>{
  const date = new Date(dateString);
  return date.toISOString();
},


 formatAnyDate :(input: string): string => {
  let date: Date;

  // Check if input is an ISO string or a natural language date string
  if (!isNaN(Date.parse(input))) {
    date = new Date(input);
  } else {
    date = new Date(Date.parse(input.replace(/(\d{1,2}) (\w{3,}) (\d{4})/, '$2 $1, $3')));
  }

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date format');
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' }); // Get month in "MMM" format
  const year = date.getFullYear().toString(); // Get year in "YY" format

  return `${day} ${month} ${year}`;
},

 convertDealSize: (value:number) => {
  // if(!value) return '0';
  // if (value >= 1000000000) {
  //   return (value / 1000000000).toFixed((value % 1000000000 === 0) ? 0 : 1) + 'B'; // Billions
  // } else if (value >= 1000000) {
  //   return (value / 1000000).toFixed((value % 1000000 === 0) ? 0 : 1) + 'M'; // Millions
  // } else if (value >= 1000) {
  //   return (value / 1000).toFixed((value % 1000 === 0) ? 0 : 1) + 'K'; // Thousands
  // } else {
  //   return value.toString(); 
  // }

  return Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    notation: "compact",
    compactDisplay: "long",      
  }).format(value).replace('T', 'K')
}



};
export default Utils;
